import { Component } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';

import { IWizardFile } from 'app/files/file.model';

@Component({
    selector: 'file-list',
    templateUrl: 'file-list.component.html',
    styleUrls: ['file-list.component.scss']
})
export class FileListComponent {

    @Input()
    files: IWizardFile[];

    @Output()
    removeFile = new EventEmitter<IWizardFile>();

    remove(file: IWizardFile): void {
        this.removeFile.emit(file);
    }

}